<template>
    <el-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="540px"
        custom-class="P-UserchangePwd"
        :before-close="handleClose">
        <div class="P-UserchangePwdCon">
            <el-form :model="popForm" :rules="rules" label-width="110px" ref="popForm" class="P-UserchangePwdForm">
                <el-form-item label="原密码：" prop="oldPwd">
                    <el-input :type="oldPwdType" placeholder="请输入原密码" v-model="popForm.oldPwd" >
                        <i slot="suffix" :class="showOldEye?'icon-view':'icon-close'" class="el-input__icon eye-icon" @click="onChangePwd('showOldEye','oldPwdType')"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="新密码：" prop="newPwd">
                    <el-input :type="newPwdType" placeholder="请输入新密码，6-20位字母+数字" v-model="popForm.newPwd"  >
                        <i slot="suffix" :class="showNewEye?'icon-view':'icon-close'" class="el-input__icon eye-icon" @click="onChangePwd('showNewEye','newPwdType')"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="确认新密码：" prop="tpmpwd">
                    <el-input :type="confirmPwdType" placeholder="请再次输入新密码" v-model="popForm.tpmpwd"  >
                        <i slot="suffix" :class="showConfrimEye?'icon-view':'icon-close'" class="el-input__icon eye-icon" @click="onChangePwd('showConfrimEye','confirmPwdType')"></i>
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="onCancle">取 消</el-button>
            <el-button type="primary" @click="updatepwd">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import md5 from 'js-md5'


import "./userInfo.less";
export default {
    name: "alertPwd",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
            callback(new Error('请输入密码'));
            } else {
                if (this.popForm.newPwd !== '') {
                    this.$refs.popForm.validateField('checkPass');
                }
                let rexPwd = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$/
                if(!rexPwd.test(this.popForm.newPwd)) {
                    callback(new Error('请输入6-20位字母+数字!')); 
                }
            callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.popForm.newPwd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            dialogVisible:false,
            showOldEye:false,
            showNewEye:false,
            showConfrimEye:false,
            oldPwdType:'password',
            newPwdType:'password',
            confirmPwdType:'password',
            popForm:{
                oldPwd:'',
                newPwd:'',
                tpmpwd:''
            },
            rules:{
                oldPwd:[
                    { required: true, message: '请输入原密码', trigger: 'blur' }
                ],
                newPwd: [
                    {  required: true, validator: validatePass, trigger: 'blur' }
                ],
                tpmpwd: [
                    {  required: true, validator: validatePass2, trigger: 'blur' }
                ]
            },
        };
    },
    props:{
        visible:{type:Boolean,default:false},
    },
    methods: {
        handleClose(done){
            this.onCancle()
            done()
        },
        onCancle(){
            this.$emit('update:visible',false)
        },
        onChangePwd(classKey,typeKey){
            this[classKey] = !this[classKey]
            this[typeKey] = !this[classKey] ? 'password':''
        },
         // 修改密码
        updatepwd() {
            let me = this
            me.$refs.popForm.validate(valid => {
                if(valid){
                    let dat = {
                        oldPassword: me.popForm.oldPwd,
                        newPassword: me.popForm.newPwd
                    }
                    dat.oldPassword = md5(dat.oldPassword);
                    dat.newPassword = md5(dat.newPassword);
                    requestDat.post({
                        url:"/updPwd",
                        data:dat
                    }).then((res)=>{
                        this.$tip('修改成功，请重新登录')
                        this.$store.dispatch('delAllViews')
                        let userphone = $storage.getItem('userphone',1)
                        localStorage.clear();
                        sessionStorage.clear();

                         let sessLoginForm = {
                            phone:userphone,
                            password:me.popForm.newPwd
                        }
                        
                        $storage.setItem("savePwd",sessLoginForm,1)
                        $storage.setItem("userphone",userphone,1)
                        this.$router.push({path:'/login'})
                    },(err)=>{

                    })
                }
            })
        },

    },
    watch:{
        visible:{
            handler(val){
                this.dialogVisible = val
            },
            immediate:true
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/userInfo/alertPwd.vue